//
// Copyright 2020 DXOS.org
//

import { lazy } from 'react';

export const SignalPanel = lazy(() => import('./SignalPanel'));
export const SwarmPanel = lazy(() => import('./SwarmPanel'));
export const NetworkPanel = lazy(() => import('./NetworkPanel'));
